<template>
  <div>
    <section class="py-11 py-md-12 bg-contacto" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8 text-center">
          
            <!-- Heading -->
            <h1 class="display-4 mt-2 py-3 font-weight-bold text-white">
              Estamos aquí para compartir
            </h1>

            <!-- Text -->
            <p class="lead text-white-75 mb-0 text-white">
              Comparte tus ideas, inquietudes o preguntas sobre el mundo Agile con la comunidad.
            </p>
            <p class="lead text-white-75 mb-0 text-white">
              Te gusta el contenido de la página y del canal de Youtube…
            </p>
            <p class="lead text-white-75 mb-0 text-white">
              Te gustaría consultarnos más de cualquier tema que te ronda la cabeza…
            </p>
            <p class="lead text-white-75 mb-0 text-white">
              Quieres participar con nosotros en alguna de estas experiencias…
            </p>

          </div>
        </div> <!-- / .row -->
      </div> <!-- / .container -->
    </section>

    <!-- SHAPE
    ================================================== -->
    <div class="position-relative">
      <div class="shape shape-bottom shape-fluid-x svg-shim text-light">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"/>
            </svg>
      </div>
    </div>

    <!-- INFO
    ================================================== -->
    <section class="py-4 py-md-5 border-bottom border-gray-300 mt-12" id="info">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <!-- Button -->
            <a href="#info" class="btn btn-white btn-rounded-circle shadow lift mt-n9 mt-md-n10 " >
              <font-awesome-icon :icon="['fas','arrow-down']" />
            </a>
          </div>
        </div> <!-- / .row -->
        <div class="row">
          <div class="col-12 col-md-4 text-center border-right border-gray-300">

          </div>
          <div class="col-12 col-md-4 text-center border-right border-gray-300">

                  <!-- Heading -->
                  <h6 class="text-uppercase text-gray-700 mb-1">
                    Escríbenos a:
                  </h6>

                  <!-- Link -->
                  <a href="#" ref="emailLink" class="h4">
                    Cargando correo...
                  </a>

          </div>
          <div class="col-12 col-md-4 text-center">



          </div>
        </div> <!-- / .row -->
      </div>
    </section>
  </div>
</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';

import bgImage from '../assets/cover-5.jpg';

library.add(faArrowDown); // Add specific icon used in this component

export default {
    computed: {
        backgroundImage () {
            // Use the imported image variable
            return bgImage;
        }
    },
    mounted() {
        const user = 'hola';
        const domain = 'agilesinfiltros.com';
        const email = user + '@' + domain;
        const emailLink = this.$refs.emailLink;

        if (emailLink) {
            emailLink.href = 'mailto:' + email;
            emailLink.textContent = email;
        }
    }
}
</script>
